module.exports = __webpack_public_path__ + "static/img/fixLogo.7276cf2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fixLogo.gif
// module id = hAv9
// module chunks = 0